const workingTime: number = 9;
export function calculateOvertime(attendanceDetails: any[]) {
    console.log(attendanceDetails, "Attendance details")
    return attendanceDetails.map(attendance => {
        const overtimeHours = calculateOvertimeForAttendance(attendance);
        return {
            ...attendance,
            overtimeHours: overtimeHours
        };
    });
}

function calculateOvertimeForAttendance(attendance: { workingHours: string; }) {
    if (attendance.workingHours) {
        // Split the working hours into hours, minutes, and seconds
        const workingHoursParts = attendance.workingHours.split(':');
        const hours = parseInt(workingHoursParts[0]);
        const minutes = parseInt(workingHoursParts[1]);
        const seconds = parseInt(workingHoursParts[2]);

        // Calculate total seconds worked
        const totalSecondsWorked = hours * 3600 + minutes * 60 + seconds;

        // Calculate total overtime seconds
        const overtimeSeconds = totalSecondsWorked - (workingTime * 3600);

        if (overtimeSeconds > 0) {
            // Only full hours count as overtime, e.g. 1:59:59 is counted as 1 hour
            const overtimeHours = Math.floor(overtimeSeconds / 3600);

            // Return the formatted overtime hours, minutes, and seconds
            return `${overtimeHours.toString().padStart(2, '0')}:00:00`;
        } else {
            // If there's no positive overtime, return zero
            return '00:00:00';
        }
    }

    return null;
}

